import * as React from 'react'
import { useIntl } from '@/intl'
import NextStepButton from '@/scopes/checkout/components/CheckoutNextStep/NextStepButton'
import { RebookingPaymentBanner } from '@/scopes/checkout/components/RebookingPayment/RebookingPaymentBanner'
import { useBookingDraftQuery } from '@/scopes/checkout/domain/hooks'
import { Payment } from '@/scopes/payment/components/Payment'
import { usePaymentActions } from '@/scopes/payment/domain/PaymentContext'
import { hidesPaymentOptions } from '@/scopes/payment/domain/policies/paymentResult'
import { getRebookingPaymentStatus } from '@/scopes/payment/domain/policies/rebookingPaymentStatus'
import { AdyenPaymentStatusValues, PaymentLoadStatusValues, RebookingPaymentStatusValues } from '@/scopes/payment/domain/types'
import { useEffectivePaymentResult } from '@/scopes/payment/infrastructure/useEffectivePaymentResult'
import { usePaymentStore } from '@/scopes/payment/infrastructure/usePaymentStore'

export function RebookingPayment() {
  const intl = useIntl()
  const { data } = useBookingDraftQuery()
  const loadStatus = usePaymentStore(state => state.loadStatus)
  const paymentOptions = usePaymentStore(state => state.paymentOptions)
  const status = usePaymentStore(state => state.status)
  const { effectivePaymentResult } = useEffectivePaymentResult()
  const actions = usePaymentActions()
  const nextStep = data?.navigation?.nextStep

  const rebookingStatus
    = data?.isRebooking
      && loadStatus === PaymentLoadStatusValues.SUCCESS
      && paymentOptions
      && !hidesPaymentOptions(effectivePaymentResult)
      ? getRebookingPaymentStatus(paymentOptions)
      : null

  const shouldSkipPayment
    = rebookingStatus === RebookingPaymentStatusValues.FULLY_COVERED
      || rebookingStatus === RebookingPaymentStatusValues.DOWN_PAYMENT_COVERED

  if (shouldSkipPayment && paymentOptions && data?.isRebooking) {
    return (
      <>
        <RebookingPaymentBanner status={rebookingStatus} amountAlreadyPaid={paymentOptions.amountAlreadyPaid} />

        {nextStep?.url && (
          <NextStepButton
            text={nextStep.text || intl.formatMessage({ id: 'checkout_scope_rebooking_next_step_button' })}
            disabled={status === AdyenPaymentStatusValues.SUBMITTING}
            isLoading={status === AdyenPaymentStatusValues.SUBMITTING}
            onClick={() => actions.nextStepRequested(nextStep.url)}
          />
        )}
      </>
    )
  }

  return (
    <>
      {rebookingStatus && rebookingStatus !== RebookingPaymentStatusValues.NOT_PAID && paymentOptions && (
        <RebookingPaymentBanner status={rebookingStatus} amountAlreadyPaid={paymentOptions.amountAlreadyPaid} />
      )}
      <Payment />
    </>
  )
}
